import { lazy } from "react";
import { ElementDetails } from "@/lib/types";

export const details = {
  name: "Time",
  description: "Display the current time and date",
  category: "Widget",
  grid: {
    extraSmall: [1, 1],
    small: [2, 1],
    medium: [2, 2],
  },
  gridNames: {
    extraSmall: "Extra Small",
    small: "Small",
    medium: "Medium",
  },
  context: lazy(() =>
    import("./Context").then(m => ({ default: m.TimeContext })),
  ),
  setup: lazy(() =>
    import("./Settings").then(m => ({ default: m.TimeSettings })),
  ),
  defaultProps: {
    timeFormat: "hh:mm:ss",
    dateFormat: "EEE dd MMM yyyy",
    timeAlign: "center",
    dateAlign: "center",
    gap: "0",
    size: "medium",
    display: "scrolling",
  },
} as ElementDetails;
